import { useState, useMemo } from "react";
import { api } from "../../../../services/api";
import { useInfiniteQuery } from "@tanstack/react-query";

export const useCertifications = () => {
    const [filter, setFilter] = useState({
        isActive: "active",
        name: "",
    });

    const {
        data: certificationData,
        isLoading: isLoadingCertifications,
        isFetching: isFetchingCertifications,
        refetch: refetchCertifications,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
    } = useInfiniteQuery({
        queryKey: ["certifications-list", filter.isActive, filter.name],
        queryFn: ({ pageParam }) =>
            api.getCertifications({
                ...filter,
                isActive: filter.isActive === "active",
                after: pageParam,
            }),
        getNextPageParam: (lastPage) => {
            return lastPage?.data?.links?.after || undefined;
        },
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        cacheTime: 0,
    });

    const certifications = useMemo(
        () =>
            certificationData?.pages?.flatMap(
                (page) => page?.data?.data ?? []
            ) ?? [],
        [certificationData?.pages]
    );

    const certificationsMeta = certificationData?.pages?.[0]?.data?.metadata;

    return {
        certifications,
        certificationsMeta,
        isLoadingCertifications,
        isFetchingCertifications,
        setFilter,
        filter,
        refetchCertifications,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
    };
};
